import useCommonStore from "@/store/commonStore";
import { Minus, Plus } from "lucide-react";

interface AddQuantityProps {
    quantity: number;
    onAdd: () => void;
    onRemove: () => void;
    disabled?: boolean;
    className?: string;
}

export default function AddQuantity({
    quantity,
    onAdd,
    onRemove,
    disabled = false,
    className = "",
}: AddQuantityProps) {
    const { translations } = useCommonStore();    
    const removeLabel = translations?.["remove"] || "Remove";
    const addLabel = translations?.["add"] || "Add";
    return quantity > 0 ? (
        <div className={`relative animated-snake-border bg-[linear-gradient(90deg,_#F8DCC4_0%,_#FFFCF9_235.71%)] text-[#6D401A] rounded-[10px] font-medium text-sm flex items-center ${className}`}>
            <span className="flex justify-center gap-1 items-center bg-[#F8DCC4] p-1 rounded-[10px]">
                <button aria-label={removeLabel} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onRemove(); }} disabled={disabled}><Minus className="w-4 h-4"/></button>
                <span className="font-bold">{quantity}</span>
                <button aria-label={addLabel} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAdd(); }} disabled={disabled}><Plus className="w-4 h-4"/></button>
            </span>
        </div>
    ) : (
        <button
        name="add"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAdd(); }}
            disabled={disabled}
            className={`relative animated-snake-border bg-[linear-gradient(90deg,_#F8DCC4_0%,_#FFFCF9_235.71%)] text-[#6D401A] border-none rounded-[10px] font-medium text-sm ${className}`}
        >
            <span className="flex justify-center gap-1 items-center bg-[#F8DCC4] p-1 rounded-[10px]">
                <Plus className="w-4 h-4"/>{translations?.["add"]||"Add"}
            </span>
        </button>
    );
}